import { Component, EventEmitter, HostListener, OnInit, Output  } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'shortcut-configurator',
  templateUrl: 'shortcut-configurator.html',
  providers: [ UtilsProvider ]
    })

export class ShortcutConfiguratorComponent   implements OnInit {
  elements: Array<{ type: string, id: string }> = [];
  shortcuts: any = {}; // Almacena los shortcuts configurados por página
  currentPage: string = '';
  isModalOpen: boolean = false; // Estado para controlar si el modal está abierto o cerrado
  keys: string[] = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9'];
  @Output() shortcutAssigned = new EventEmitter<any>();
  private pressedKeys = new Set<string>();
  private isHandlingShortcut = false; // Para evitar múltiples ejecuciones
  constructor(private navCtrl: NavController, public utilsProvider:UtilsProvider,
     public toastControllers:ToastController,
  ) {

    setTimeout(() => {
      document.addEventListener('keydown', (event: KeyboardEvent) => this.handleShortcut(event));

    }, 1000);
  }
  // this.handleShortcut = this.handleShortcut.bind(this);
  toggleConfigModal() {
    this.isModalOpen = !this.isModalOpen;

    if (this.isModalOpen) {
        // Obtener los atajos guardados para la página actual
        const shortcuts = this.utilsProvider.getShortcuts(this.currentPage);

        // Asignar los atajos a los elementos de forma segura usando map
        this.elements = this.elements.map(element => ({
            ...element,
            shortcut: Object.keys(shortcuts).find(key => shortcuts[key] === element.id) || null
        }));
  }
}


  async ngOnInit() {
    document.addEventListener('keydown', this.handleShortcut);
    this.loadShortcuts();

    setTimeout(() => {
      this.identifyElements();

      // Llamamos a assignShortcut para cada elemento después de identificarlo
      this.elements.forEach(element => {
        const currentShortcuts = this.shortcuts[this.currentPage];
        if (currentShortcuts) {
          Object.keys(currentShortcuts).forEach(shortcut => {
            if (currentShortcuts[shortcut] === element.id) {
              this.assignShortcut(element.id, shortcut);
            }
          });
        }
      });
    }, 600);
  }


  ionViewDidEnter() {
    // setTimeout(() => {
    //   this.restoreShortcuts();
    // }, 600);
  }
  restoreShortcuts() {
    if (!this.shortcuts || !this.shortcuts[this.currentPage]) return;

    const currentShortcuts = this.shortcuts[this.currentPage];

    this.elements.forEach(element => {
      const assignedKey = Object.keys(currentShortcuts).find(key => currentShortcuts[key] === element.id);
      if (assignedKey) {
        (element as any).shortcut = assignedKey;
      }
    });
  }
  async ionViewDidLoad() {
    // this.loadShortcuts();
  }

  ngAfterViewInit() {
    // this.identifyElements();
  }

  identifyElements() {

    this.elements = [];


    const inputs = Array.from(document.querySelectorAll('ion-input')) as HTMLInputElement[];
    inputs.forEach((input, index) => {
      if(input.id) {
        this.elements.push({ type: 'texto', id: `${input.id}` });
        input.setAttribute('id', `${input.id}`);
      }
    });

    const inputs2 = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    inputs2.forEach((input, index) => {
      if(input.id) {
        this.elements.push({ type: 'texto', id: `${input.id}` });
        input.setAttribute('id', `${input.id}`);
      }
    });


    const searchbars = Array.from(document.querySelectorAll('ion-searchbar')) as HTMLElement[];
    searchbars.forEach((searchbar, index) => {
      if (searchbar && searchbar.id) {
        this.elements.push({ type: 'texto', id: searchbar.id });
        searchbar.setAttribute('id', searchbar.id);
      }
    });

    const buttons = Array.from(document.querySelectorAll('button')) as HTMLButtonElement[];
    buttons.forEach((button, index) => {
      if (button.id) {
          this.elements.push({ type: 'Botón', id: button.id });
          button.setAttribute('id', button.id);
        }
    });




    const uniqueButtons = Array.from(document.querySelectorAll('button[data-unique="true"]')) as HTMLButtonElement[];

    uniqueButtons.forEach((button) => {

      const id = button.id;
      if (id) {
        this.elements.push({ type: 'Botón único', id });
      }
    });

  }

  async saveShortcuts() {
    // Guardar configuraciones
    const companiasId = await localStorage.getItem('companiasId'); // Obtén el ID de la compañía
    const atajo = await this.utilsProvider.gestionarAtajos(companiasId,this.currentPage, this.shortcuts); // Llama al servicio para obtener los atajos
    const responseAtajo = JSON.parse(atajo['_body']); // Parsea la respuesta

    // Verifica que la estructura de los datos sea válida
    if (responseAtajo && responseAtajo.data && responseAtajo.data[0].length > 0) {
      // this.mensajeToast('Atajos Los datos se gestionaron con exito...')
    } else {
     this.mensajeToast('Atajos Los datos No se gestionaron verifique...')
    }
  }



  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }



  async loadShortcuts() {
    this.currentPage = this.navCtrl.getActive().name;
    const companiasId = await localStorage.getItem('companiasId');
    const atajo = await this.utilsProvider.buscarAtajos(companiasId, this.currentPage);
    const responseAtajo = JSON.parse(atajo['_body']);

    if (
      responseAtajo &&
      responseAtajo.data &&
      Array.isArray(responseAtajo.data) &&
      responseAtajo.data.length > 0 &&
      Array.isArray(responseAtajo.data[0]) &&
      responseAtajo.data[0].length > 0
    ) {
      const atajosData = responseAtajo.data[0][0]; // Solo se ejecutará si la estructura es válida
      //const atajosJson = JSON.parse(atajosData.atajo)[this.currentPage] || {};
      let atajosJson = JSON.parse(atajosData.atajo);

      if (atajosJson[this.currentPage]) {
          atajosJson = atajosJson[this.currentPage]; // Extraer solo los atajos de la página actual
      } else {
          atajosJson = {}; // Si no hay atajos para esta página, dejar vacío
      }

       this.utilsProvider.setShortcuts(this.currentPage, atajosJson);

    } else {
      this.utilsProvider.setShortcuts(this.currentPage, {});
    }


    // Cargar atajos en la vista
    this.elements.forEach((element) => {
      const currentShortcuts = this.utilsProvider.getShortcuts(this.currentPage);

      if (currentShortcuts && typeof currentShortcuts === 'object') {
        const checkShortcuts = (shortcuts) => {
          Object.keys(shortcuts).forEach((key) => {
            const value = shortcuts[key];
            const isKeyInRange = key >= "F1" && key <= "F9";
            const isValueInRange = value >= "F1" && value <= "F9";
            const valueMatchesElementId = value === element.id;

            if (isKeyInRange && !isValueInRange && valueMatchesElementId) {
              (element as any).shortcut = key;
              this.utilsProvider.shortcutAssigned.emit({ value, key });
            }

            if (typeof value === 'object' && value !== null) {
              checkShortcuts(value);
            }
          });
        };

        checkShortcuts(currentShortcuts);

        if (!(element as any).shortcut) {
          (element as any).shortcut = null;
        }
      } else {
        (element as any).shortcut = null;
      }
    });

      this.restoreShortcuts();
  }


isShortcutInUse(shortcut: string, currentElementId: string): boolean {
  return this.elements.some(element =>
      (element as any).shortcut === shortcut && element.id !== currentElementId
  );
}

  assignShortcut(elementId: string, shortcut: string): void {
    // Verifica si this.shortcuts está inicializado correctamente
    if (!this.shortcuts) {
      this.shortcuts = {};  // Inicializa this.shortcuts si no está definido
    }

    // Verifica si this.shortcuts[this.currentPage] es un objeto, sino lo inicializa
    if (!this.shortcuts[this.currentPage] || typeof this.shortcuts[this.currentPage] !== 'object') {
      this.shortcuts[this.currentPage] = {};  // Inicializa como un objeto vacío si no existe
    }

    // Verificar si el atajo ya está asignado a otro elemento en this.elements
    const existingElement = this.elements.find(element => (element as any).shortcut === shortcut);

    if (existingElement) {
      // Si el atajo ya está asignado a otro elemento, eliminar el atajo de ese elemento
      (existingElement as any).shortcut = null; // Desasignar el atajo del elemento existente
    }

    // Verificar si el atajo ya está asignado a este elemento
    const currentElement = this.elements.find(element => element.id === elementId);
    if (currentElement && (currentElement as any).shortcut === shortcut) {
      // Si el atajo ya está asignado a este elemento, no hacer nada
      (currentElement as any).shortcut = null; // Desasignar el atajo del elemento existente
      this.saveShortcuts(); // Aseguramos de guardar antes de salir si no hubo cambios
      return;
    }

    // Verificar si el atajo ya está asignado a otro elemento en la página actual
    if (this.shortcuts[this.currentPage] && this.shortcuts[this.currentPage][shortcut]) {
      // Si el atajo ya existe en this.shortcuts para esta página, evitar asignarlo nuevamente
      this.saveShortcuts(); // Aseguramos de guardar antes de salir si no hubo cambios
      return;
    }

    // Verificar si elementId ya existe en this.shortcuts para la página actual
    const currentShortcuts = this.shortcuts[this.currentPage];
    for (const key of Object.keys(currentShortcuts)) {
        if (currentShortcuts[key] === elementId) {
            // Si elementId ya existe, actualizar el atajo
            currentShortcuts[key] = shortcut; // Actualizar el atajo existente
            this.saveShortcuts();
            break; // Salir del bucle una vez que se haya actualizado
        }
    }

    // Asignar el nuevo atajo al elemento
    this.shortcuts[this.currentPage][shortcut] = elementId;

    // Buscar el elemento actual y agregar la propiedad 'shortcut' si no existe
    if (currentElement) {
      (currentElement as any).shortcut = shortcut; // Forzamos la propiedad si no existe
    }

    // Guardar los atajos después de que los cambios se hayan realizado
    this.saveShortcuts();
    // Obtener los atajos guardados para la página actual
    const shortcuts = this.utilsProvider.getShortcuts(this.currentPage);

    // Asignar los atajos a los elementos de forma segura usando map
    this.elements = this.elements.map(element => ({
        ...element,
        shortcut: Object.keys(shortcuts).find(key => shortcuts[key] === element.id) || null
    }));
  }


  @HostListener('keydown', ['$event'])
  handleShortcut(event: KeyboardEvent) {
      const keyPressed = event.key;

      // Verificar si es una tecla F1 - F9
      if (keyPressed.startsWith('F') && !isNaN(Number(keyPressed[1])) && Number(keyPressed[1]) >= 1 && Number(keyPressed[1]) <= 9) {
          event.preventDefault();
          event.stopPropagation();

          console.log(`🔹 Atajo presionado: ${keyPressed}`);

          // Evitar ejecuciones múltiples mientras la tecla está presionada
          if (this.isHandlingShortcut) {
              return;
          }
          this.isHandlingShortcut = true; // Bloquea repeticiones rápidas

          if (this.shortcuts[this.currentPage] && this.shortcuts[this.currentPage][keyPressed]) {
              const elementId = this.shortcuts[this.currentPage][keyPressed];
              const element = document.getElementById(elementId);

              if (element) {
                  if (element.tagName === 'BUTTON' || element.tagName === 'ION-BUTTON') {
                      console.log("🖱️ Simulando clic en el botón...");
                      (element as HTMLButtonElement).click();
                  } else if (['ION-INPUT', 'ION-SEARCHBAR', 'INPUT'].indexOf(element.tagName) !== -1) {
                      setTimeout(() => {
                          let inputElement: HTMLInputElement | null = element.querySelector('input') || (element as HTMLInputElement);
                          if (inputElement) {
                              console.log("📌 Enfocando el input...");
                              inputElement.focus();
                          }
                      }, 50);
                  }
              } else {
                  console.log("⚠️ No se encontró el elemento en el DOM.");
              }
          } else {
              console.log("❌ No se encontró el atajo en shortcuts.");
          }

          // 🔹 Resetear la bandera después de un pequeño tiempo (100ms) para evitar bloqueos
          setTimeout(() => {
              this.isHandlingShortcut = false;
          }, 100);
      }
  }

//   ngOnDestroy() {
//     console.log("🗑️ Eliminando evento de teclado...");
//     window.removeEventListener('keydown', this.handleShortcut);
// }

ngOnDestroy() {
  console.log("🗑️ Eliminando evento de teclado...");
  document.removeEventListener('keydown', this.handleShortcut);
}

}



// WEBPACK FOOTER //
// ./src/components/shortcutconfigurator/shortcut-configurator.ts